<template>
  <div class="d-flex gap-2 align-items-center flex-wrap">
    <featured-vendor-tag v-for="tag in featuredTags" :key="tag.id" :tag="tag" :class="tagClass"></featured-vendor-tag>
  </div>
</template>

<script>
  import FeaturedVendorTag from './FeaturedVendorTag.vue';
  import { tenantInfoMixin } from '@/js/custom-vue-mixins';

  export default {
    name: 'FeaturedVendorTagGroup',
    components: {
      FeaturedVendorTag,
    },
    mixins: [tenantInfoMixin],
    props: {
      tags: {
        // pass in any tags, we filter and show only the 'is_featured' ones
        type: Array,
        default: () => [],
      },
      tagClass: {
        // passed on to featured-vendor-tag component
        type: [String, Array, Object],
        default: '',
      },
    },
    computed: {
      // REMOVED - only use this for original vendor tags, not spl tags
      // dynamicTaggingEnabled() {
      //   return this.$getTenantFlag('taxonomy_vendor_tags', false);
      // },
      featuredTags() {
        // doing like this to avoid linter barking at me
        // if (this.dynamicTaggingEnabled) {
        //   return this.tags;
        // }

        const hasArray = this.tags && Array.isArray(this.tags);
        return hasArray ? this.tags.filter((t) => t.is_featured) : [];
      },
    },
  };
</script>

<style></style>
